"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DRGChangeService = function () {
  function DRGChangeService($http) {
    _classCallCheck(this, DRGChangeService);

    this.$http = $http;
  }

  _createClass(DRGChangeService, [{
    key: "getChangeTypes",
    value: function getChangeTypes() {
      return this.$http.get(WEBSERVICEURL + "/dataagility/api/service.drgchangetypes");
    }
  }]);

  return DRGChangeService;
}();

var AuditprogramdrgchangesController = function AuditprogramdrgchangesController($http, $rootScope, $scope, DTOptionsBuilder, DTColumnBuilder, User, CONST, Constants, dateTimeHelper, materialButtons, datePicker, ChangeCategory, EpisodeDrgAuditTypeService, CoderService, FunctionService, AuditRuleService) {
  _classCallCheck(this, AuditprogramdrgchangesController);

  this.dRGChangeService = new DRGChangeService($http);

  this.datatableApi;
  this.user = User.getUser();
  this.name = "Audited Medical Records";
  this.episodeValue = "";
  this.specialtyString = "";
  this.separationString = "";
  this.locale = "en-au";
  $scope.dateTimeHelper = dateTimeHelper;
  this.url = WEBSERVICEURL + "/dataagility/api/service.auditprogramdrgchanges";
  this.initUrl = this.url + "?startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
  this.totalProjectedWiesDifference = 0;

  this.errorCategoryOptions = [];
  $scope.promise = ChangeCategory.data().then(function successCallback(response) {
    $scope.vm.errorCategoryOptions = response;
  }, function errorCallback(response) {
    console.error(response);
  });

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
    $scope.vm.functionSettings = response.functionSettings;

    // All Private Clients should be active, All Public should be inactive
    if ($scope.vm.episodeValue === '$') {
      console.log('WIES vars set to private');
      $scope.vm.wiesDefault = "0.00";
      $scope.vm.wiesParseAmount = 2;
    } else {
      console.log('WIES vars set to public');
      $scope.vm.wiesDefault = "0.0000";
      $scope.vm.wiesParseAmount = 4;
    }

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === "string") {
          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
        } else {
          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
    });

    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
  });

  materialButtons.render();

  materialButtons.processing();

  // This is needed to obtain the sum of datatable column values
  jQuery.fn.dataTable.Api.register("sum()", function () {
    return this.flatten().reduce(function (a, b) {
      if (typeof a === "string") {
        a = a.replace(/[^\d.-]/g, "") * 1;
      }
      if (typeof b === "string") {
        b = b.replace(/[^\d.-]/g, "") * 1;
      }

      return a + b;
    }, 0);
  });

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  $scope.drawCallback = function (nRow) {
    // tell DataTables we're using Aussie-formatted dates for ordering
    $.fn.dataTable.moment("DD/MM/YYYY");
    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");

    var table = $("#auditTable").DataTable(),
        total = 0;

    for (var i = 0; i < table.data().length; i++) {
      if (parseFloat(table.data()[i].wiesDiff)) total += parseFloat(table.data()[i].wiesDiff);
    }

    $(".reports__stats #total-queries").html("Total Episodes: " + table.data().count().toLocaleString());

    $(".reports__stats #total-proj-wies").html($scope.vm.episodeValue + " Difference Sum: " + total.toFixed($scope.vm.wiesParseAmount));
  };

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    headers: {
      Authorization: "Bearer " + $rootScope.globals.currentUser.token
    },
    url: $scope.vm.initUrl,
    type: "GET"
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($("#auditTable").DataTable());
  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print",
    text: ""
  }, {
    extend: "csvHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "",
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]).withColumnFilter({
    //sPlaceHolder: "head:after",
    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "date-range" }]
  });

  function yesNo(data) {
    return data === true ? "Y" : "N";
  }

  this.dtColumns = [DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("los").withTitle("LOS").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalDrg").withTitle("Prev. DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalWies").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
  }), DTColumnBuilder.newColumn("originalCoder").withTitle("Original Coder").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("updateName").withTitle("Update Name").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("typeOfChange").withTitle("Type of Change").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("ruleName").withTitle("Audit Rule").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditType").withTitle("Audit Type").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryType").withTitle("Query Type").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("errorCategory").withTitle("Error Category").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("ICUHours").withTitle("ICU Hours").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return $scope.dateTimeHelper.convertICUHours(data);
  }), DTColumnBuilder.newColumn("mechVentilationHours").withTitle("MV Hours").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("NIVentilationHours").withTitle("NIV Hours").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentDrg").withTitle("Current DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentWies").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
  }), DTColumnBuilder.newColumn("wiesDiff").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
  }), DTColumnBuilder.newColumn("wiesOnly").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? data.localeCompare('y') === 1 ? 'Yes' : 'No' : '';
  }), DTColumnBuilder.newColumn("patientClassification").withTitle("Patient Classification").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("status").withTitle("Episode Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];

  function setDtHeaders(table) {
    $(table.column(getIndexOfColumn('dischargeDate')).header()).html($scope.vm.separationString + " Date");
    $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
    $(table.column(getIndexOfColumn('originalWies')).header()).html("Prev. " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn('currentWies')).header()).html("Current " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn('wiesDiff')).header()).html($scope.vm.episodeValue + " Difference");
    $(table.column(getIndexOfColumn('wiesOnly')).header()).html($scope.vm.episodeValue + " Only");
  }

  function getIndexOfColumn(columnName) {
    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === columnName;
    });
    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
  }

  // Search filters
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];

  this.specialty = {
    selectedSpecialty: []
  };
  this.specialtyOptions = [];

  this.auditType = {
    selectedAuditType: []
  };
  this.auditTypeOptions = [];

  this.changeType = {
    selectedChangeType: []
  };
  this.changeTypeOptions = [];

  this.errorCategory = {
    selectedErrorCategory: []
  };

  this.coder = {
    selectedCoder: []
  };
  this.coderOptions = [];

  this.queryModifiedBy = {
    selectedQueryModifiedBy: []
  };

  this.queryType = {
    selectedQueryType: ""
  };
  this.queryTypeOptions = [];
  this.queryTypeOptionsWithIds = [];

  this.auditRule = {
    selectedAuditRule: []
  };
  this.auditRuleOptions = [];
  this.auditRuleOptionsWithIds = [];

  this.wiesOnly = {
    selectedWiesOnly: ""
  };
  this.wiesOnlyOptions = ["Yes", "No"];

  this.statusOptions = CONST.STATUS;
  this.status = {
    selectedStatus: []
  };

  Constants.campusData().then(function successCallback(response) {
    $scope.vm.campusOptions = response;
    filterCampus($scope.vm.campusOptions);
  });

  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
    $scope.vm.specialtyOptions = response.specialties;
    filterSpecialty("minus");
    // Can load divisions if needed??
  });

  EpisodeDrgAuditTypeService.types().then(function successCallback(response) {
    $scope.vm.auditTypeOptionsWithIds = response;
    angular.forEach(response, function (value, key) {
      if ($scope.vm.auditTypeOptions.indexOf(value.name) === -1) $scope.vm.auditTypeOptions.push(value.name);
    });
  });

  AuditRuleService.data().then(function successCallback(response) {
    $scope.vm.auditRuleOptionsWithIds = response;
    angular.forEach(response, function (value, key) {
      if ($scope.vm.auditRuleOptions.indexOf(value.name) === -1) $scope.vm.auditRuleOptions.push(value.name);
    });
  });

  $scope.vm.dRGChangeService.getChangeTypes().then(function successCallback(response) {
    angular.forEach(response.data, function (value, key) {
      if ($scope.vm.changeTypeOptions.indexOf(value.drgChangeType) === -1) {
        $scope.vm.changeTypeOptions.push(value.drgChangeType);
      }
    });
  });

  CoderService.data().then(function successCallback(response) {
    angular.forEach(response, function (item, key) {
      $scope.vm.coderOptions.push(item.name);
    });
  });

  Constants.getQueryTemplateData().then(function (data) {
    if (!$scope.vm.queryTemplateData) {
      angular.forEach(data, function (value, key) {
        $scope.vm.queryTypeOptions.push(value.queryTemplateName);
      });
    }
  });

  this.startDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
    }
  };
  this.endDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "days"),
      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
    }
  };

  // callbacks for lx-selects and lx-date-picker
  datePicker.autoClose($scope);
  this.filterCallback = filterCallback;

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  function filterSpecialty(swap) {
    $scope.vm.specialty.selectedSpecialty = [];
    if (swap === "add") {
      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
    }
  }

  function filterAuditType(swap) {
    $scope.vm.auditType.selectedAuditType = [];
    if (swap === "add") {
      $scope.vm.auditType.selectedAuditType = $scope.vm.auditTypeOptions;
    }
  }

  function filterChangeType(swap) {
    $scope.vm.changeType.selectedChangeType = [];
    if (swap === "add") {
      $scope.vm.changeType.selectedChangeType = $scope.vm.changeTypeOptions;
    }
  }

  function filterErrorCategory(swap) {
    $scope.vm.errorCategory.selectedErrorCategory = [];
    if (swap !== "minus") {
      angular.forEach($scope.vm.errorCategoryOptions, function (value, key) {
        $scope.vm.errorCategory.selectedErrorCategory.push($scope.vm.errorCategoryOptions[$scope.vm.errorCategoryOptions.indexOf(value)].changeCategory);
      });
    }
  }

  function filterCoder(swap) {
    $scope.vm.coder.selectedCoder = [];
    if (swap !== "minus") {
      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions;
    }
  }

  function filterQueryModifiedBy(swap) {
    $scope.vm.queryModifiedBy.selectedQueryModifiedBy = [];
    if (swap !== "minus") {
      $scope.vm.queryModifiedBy.selectedQueryModifiedBy = $scope.vm.coderOptions;
    }
  }

  function filterStatus(swap) {
    $scope.vm.status.selectedStatus = [];
    if (swap !== "minus") {
      $scope.vm.status.selectedStatus = $scope.vm.statusOptions;
    }
  }

  function filterAuditRule(swap) {
    $scope.vm.auditRule.selectedAuditRule = [];
    if (swap !== "minus") {
      $scope.vm.auditRule.selectedAuditRule = $scope.vm.auditRuleOptions;
    }
  }

  function filterCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  function checkParam(param) {
    if (param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  this.changeData = changeData;

  function changeData() {
    var campus = "";
    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
        campus = $scope.vm.user.campus;
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
    } else {
      campus = $scope.vm.campus.selectedCampus;
    }
    var newUrl = $scope.vm.url + "?startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&speciality=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&campus=" + checkParam(campus) + "&auditType=" + checkParam($scope.vm.auditType.selectedAuditType) + "&changeType=" + checkParam($scope.vm.changeType.selectedChangeType) + "&errorCategory=" + checkParam($scope.vm.errorCategory.selectedErrorCategory) + "&coder=" + checkParam($scope.vm.coder.selectedCoder) + "&queryType=" + ($scope.vm.queryType.selectedQueryType ? $scope.vm.queryType.selectedQueryType : "") + "&modifiedBy=" + checkParam($scope.vm.queryModifiedBy.selectedQueryModifiedBy) + "&wiesOnly=" + ($scope.vm.wiesOnly.selectedWiesOnly ? $scope.vm.wiesOnly.selectedWiesOnly : "") + "&status=" + checkParam($scope.vm.status.selectedStatus) + "&auditRule=" + checkParam($scope.vm.auditRule.selectedAuditRule);

    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
  }

  function search() {
    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    var clearAuditTable = auditTable.search("").draw();

    filterCampus("minus");
    filterSpecialty("minus");
    filterAuditType("minus");
    filterChangeType("minus");
    filterErrorCategory("minus");
    filterCoder("minus");
    filterQueryModifiedBy("minus");
    filterAuditRule("minus");

    // re-draw tabele on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      $scope.vm.changeData();
    });
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {
    switch (thisFilter) {
      case "campus":
        if (thisModifier === "add") {
          filterCampus("add");
        } else {
          filterCampus("minus");
        }

        break;

      case "auditType":
        if (thisModifier === "add") {
          filterAuditType("add");
        } else {
          filterAuditType("minus");
        }

        break;

      case "specialty":
        if (thisModifier === "add") {
          filterSpecialty("add");
        } else {
          filterSpecialty("minus");
        }

        break;

      case "changeType":
        if (thisModifier === "add") {
          filterChangeType("add");
        } else {
          filterChangeType("minus");
        }

        break;

      case "errorCategory":
        if (thisModifier === "add") {
          filterErrorCategory("add");
        } else {
          filterErrorCategory("minus");
        }

        break;

      case "coder":
        if (thisModifier === "add") {
          filterCoder("add");
        } else {
          filterCoder("minus");
        }

        break;

      case "auditRule":
        if (thisModifier === "add") {
          filterAuditRule("add");
        } else {
          filterAuditRule("minus");
        }

        break;

      case "queryModifiedBy":
        if (thisModifier === "add") {
          filterQueryModifiedBy("add");
        } else {
          filterQueryModifiedBy("minus");
        }

        break;

      case "status":
        if (thisModifier === "add") {
          filterStatus("add");
        } else {
          filterStatus("minus");
        }

        break;
      default:
        break;
    }
  }
};

exports.default = AuditprogramdrgchangesController;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramdrgchanges/auditprogramdrgchanges.controller.js